/* Presentation order only: catalogue identities, printed numbers and saved links stay intact. */
(() => {
  const backLoadedSeries=new Set(['EX Series','Diamond & Pearl Series','Platinum Series','HeartGold & SoulSilver Series','Call of Legends Series','Black & White Series','XY Series','Sun & Moon Series','Sword & Shield Series','Scarlet & Violet Series','Mega Evolution series']);
  function reverse(set){
    if(set.browseOrder==='ascending')return false;
    if(set.browseOrder==='descending')return true;
    if(set.game&&!/^(pokemon|pokémon)$/i.test(set.game))return false;
    // Promo numbering, energy-only sets and reprint collections do not imply a hit order.
    if(/promo|energies|trainer kit|starter set|classic collection/i.test(set.name||''))return false;
    if(backLoadedSeries.has(set.series))return true;
    // Older secret rares and separately numbered holo/gallery sections are also at the back.
    return (set.cards||[]).some(card=>{
      const number=String(card.number||'').trim(),parts=number.match(/^(\d+)\s*\/\s*(\d+)$/);
      return parts?Number(parts[1])>Number(parts[2]):/^(?:TG|GG|SV|RC|SH|SL|H)\d+/i.test(number);
    });
  }
  function cards(set){const ordered=(set.cards||[]).slice();return reverse(set)?ordered.reverse():ordered;}
  window.KillinSetOrder={cards,reverse};
})();
